<template>
	<div style="padding-top: 16px; padding-left: 4px; padding-right: 4px">
		<v-snackbar
			v-model="snackbar"
			:timeout="10000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<h4>Lieferverzögerung der Aufträge in Prozent im Vergleich zu anderen Blexon-Partnern</h4>
		<v-select label="Jahr" :items="years" v-model="year"></v-select>
		<v-progress-linear indeterminate v-if="loading" color="accent"></v-progress-linear>
		<v-layout row v-if="!loading && noData">
			<v-flex text-center> Keine Daten über das gewählte Jahr verfügbar. </v-flex>
		</v-layout>
		<canvas v-else ref="diagramCanvas"></canvas>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
import Chart from "chart.js";

export default {
	data() {
		return {
			snackbar: false,
			snackbarText: "",
			loading: false,
			year: new Date().getFullYear(),
			delayReports: [],
			chart: null,
			noData: true,
		};
	},
	mounted() {
		this.loadReport();
	},
	watch: {
		year() {
			this.loadReport();
		},
	},
	computed: {
		years() {
			var lastYears = [];
			for (let index = new Date().getFullYear(); index >= 2012; index--) {
				lastYears.push(index);
			}
			return lastYears;
		},
		currentFertiger() {
			return this.$store.getters.currentFertiger(this.$route.params.fertigerId);
		},
	},
	methods: {
		async loadReport() {
			try {
				this.loading = true;
				let response = await httpClient().get(
					`api/Report/GetDeliveryDelay?year=${this.year}&fertigerId=${this.currentFertiger.id}`
				);
				this.delayReports = response.data;
				for (const report of this.delayReports) {
					let fertiger = this.$store.state.fertiger.filter(
						(f) => f.id === report.fertigerId
					)[0];
					if (!fertiger) {
						report.fertigerId = ""; // Hide names of other fertigers
					} else if (fertiger.id >= 0) {
						report.fertigerId = fertiger.name;
					}
				}
				this.delayReports = this.delayReports.sort(
					(a, b) => b.fertigerId.length - a.fertigerId.length
				);
				this.noData = this.delayReports.length <= 0;
				this.updateDiagram();
			} catch (err) {
				console.error("Loading delay reports failed.");
				console.error(err);
				this.setSnackbarText("Fehler beim Laden der Reports. Siehe Konsole.");
			} finally {
				this.loading = false;
			}
		},

		getDatasets() {
			let datasets = [
				{
					label: "Pünktlich",
					data: [...this.delayReports.map((r) => r.procentOnTime.toFixed(1))],
					backgroundColor: "#378805",
				},
				{
					label: "1 Tag verzögert",
					data: [...this.delayReports.map((r) => r.procentOneDayDelay.toFixed(1))],
					backgroundColor: "#ffad33",
				},
				{
					label: "2 Tage und mehr",
					data: [
						...this.delayReports.map((r) => r.procentMoreThenOneDayDelay.toFixed(1)),
					],
					backgroundColor: "#e10000",
				},
			];

			return datasets;
		},

		updateDiagram() {
			const labels = this.delayReports.map((r) => `${r.fertigerId}`);

			// Destroy the chart if one already exists.
			if (this.chart != null) {
				this.chart.destroy();
			}

			const ctx = this.$refs.diagramCanvas.getContext("2d");
			this.chart = new Chart(ctx, {
				// The type of chart we want to create
				type: "bar",
				// The data for our dataset
				data: {
					labels: labels,
					datasets: this.getDatasets(),
				},
				options: {
					plugins: {
						title: {
							display: true,
							text: "Lieferverzögerung",
						},
					},
					responsive: true,
					scales: {
						xAxes: [
							{
								stacked: true,
							},
						],
						yAxes: [
							{
								stacked: true,
								ticks: {
									min: 0, // minimum value
									max: 100, // maximum value
								},
							},
						],
					},
				},
			});
			this.chart.update();
		},

		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>

<style></style>
